/** Reusable Windows CMD title bar (300 wide) */
function CmdTitleBar({ title = "Eingabeaufforderung" }: { title?: string }) {
  return (
    <>
      <rect width="300" height="28" rx="5" fill="#1a1a1a" />
      <rect x="0" y="14" width="300" height="14" fill="#1a1a1a" />
      {/* CMD icon left */}
      <rect x="7" y="7" width="14" height="14" rx="2" fill="#0c2c5a" />
      <text x="14" y="18" textAnchor="middle" fontSize="8" fill="#fff" fontFamily="Courier New, monospace">C:</text>
      {/* Title centered */}
      <text x="138" y="18" textAnchor="middle" fontSize="8.5" fill="#888">{title}</text>
      {/* Windows controls – right side */}
      {/* Minimize */}
      <rect x="241" y="0" width="19" height="28" fill="transparent" />
      <text x="250" y="17" textAnchor="middle" fontSize="10" fill="#ccc">─</text>
      {/* Maximize */}
      <rect x="261" y="0" width="19" height="28" fill="transparent" />
      <rect x="266" y="9" width="9" height="9" rx="0" fill="none" stroke="#ccc" strokeWidth="1.2" />
      {/* Close – red background */}
      <rect x="281" y="0" width="19" height="28" fill="#c42b1c" rx="0" />
      <rect x="281" y="0" width="19" height="28" rx="0 0 5 0" fill="#c42b1c" />
      <text x="290" y="18" textAnchor="middle" fontSize="11" fill="#fff">×</text>
    </>
  );
}

export function IpGuideWindows() {
  return (
    <div className="space-y-6">
      {/* Step 1 */}
      <div className="flex gap-3">
        <span className="shrink-0 w-6 h-6 rounded-full bg-blue-600 text-white text-xs font-bold flex items-center justify-center mt-0.5">
          1
        </span>
        <div className="flex-1 min-w-0">
          <p className="text-sm text-gray-700 mb-3">
            Tasten{" "}
            <kbd className="bg-gray-100 border border-gray-300 rounded px-1.5 py-0.5 text-xs font-mono">Win</kbd>
            {" + "}
            <kbd className="bg-gray-100 border border-gray-300 rounded px-1.5 py-0.5 text-xs font-mono">R</kbd>{" "}
            drücken, <strong>„cmd"</strong> eingeben und <strong>OK</strong> klicken.
          </p>
          <svg viewBox="0 0 300 140" xmlns="http://www.w3.org/2000/svg" className="w-full max-w-sm mx-auto block rounded-lg" aria-hidden="true">
            {/* Windows desktop */}
            <rect width="300" height="140" fill="#0067b8" />
            {/* Taskbar */}
            <rect x="0" y="120" width="300" height="20" fill="#1a1a1a" />
            {/* Win+R badge */}
            <rect x="6" y="126" width="38" height="10" rx="2" fill="rgba(255,255,255,0.15)" />
            <text x="25" y="134" textAnchor="middle" fontSize="7" fill="#fff">Win + R</text>

            {/* Run dialog */}
            <rect x="42" y="22" width="215" height="92" rx="3" fill="#f3f3f3" stroke="#adadad" strokeWidth="0.8" />
            {/* Dialog title bar (Windows style – no colored circles) */}
            <rect x="42" y="22" width="215" height="24" rx="3" fill="#efefef" />
            <rect x="42" y="34" width="215" height="12" fill="#efefef" />
            {/* Small icon */}
            <rect x="49" y="27" width="12" height="12" rx="1" fill="#0067b8" opacity="0.8" />
            <rect x="51" y="29" width="4" height="4" rx="0.5" fill="#fff" />
            <rect x="56" y="29" width="4" height="4" rx="0.5" fill="#fff" />
            <rect x="51" y="34" width="4" height="4" rx="0.5" fill="#fff" />
            <rect x="56" y="34" width="4" height="4" rx="0.5" fill="#fff" />
            {/* Title */}
            <text x="67" y="37" fontSize="9.5" fill="#000">Ausführen</text>
            {/* Close button (Windows X) */}
            <rect x="240" y="24" width="14" height="14" rx="1" fill="#e81123" />
            <text x="247" y="34" textAnchor="middle" fontSize="9" fill="#fff">✕</text>
            {/* Content */}
            <text x="52" y="60" fontSize="8.5" fill="#444">Gib den Namen des Programms, Ordners oder</text>
            <text x="52" y="71" fontSize="8.5" fill="#444">Dokuments ein – Windows öffnet es für dich.</text>
            {/* Label + input */}
            <text x="52" y="88" fontSize="9" fill="#000">Öffnen:</text>
            <rect x="85" y="79" width="112" height="17" rx="2" fill="#fff" stroke="#0078d4" strokeWidth="1.5" />
            <text x="91" y="91" fontSize="10.5" fill="#000" fontFamily="Courier New, monospace">cmd</text>
            <rect x="119" y="83" width="1.5" height="11" fill="#000" />
            {/* OK button */}
            <rect x="201" y="79" width="48" height="17" rx="3" fill="#0078d4" />
            <text x="225" y="91" textAnchor="middle" fontSize="9.5" fill="#fff">OK</text>
          </svg>
        </div>
      </div>

      {/* Step 2 */}
      <div className="flex gap-3">
        <span className="shrink-0 w-6 h-6 rounded-full bg-blue-600 text-white text-xs font-bold flex items-center justify-center mt-0.5">
          2
        </span>
        <div className="flex-1 min-w-0">
          <p className="text-sm text-gray-700 mb-3">
            Im schwarzen Fenster <strong>„ipconfig"</strong> eintippen und{" "}
            <kbd className="bg-gray-100 border border-gray-300 rounded px-1.5 py-0.5 text-xs font-mono">Enter</kbd> drücken.
          </p>
          <svg viewBox="0 0 300 130" xmlns="http://www.w3.org/2000/svg" className="w-full max-w-sm mx-auto block rounded-lg" aria-hidden="true">
            <rect width="300" height="130" rx="5" fill="#0c0c0c" />
            <CmdTitleBar />
            {/* CMD content */}
            <text x="10" y="46" fontSize="8.5" fill="#ccc" fontFamily="Courier New, monospace">Microsoft Windows [Version 10.0.26100]</text>
            <text x="10" y="59" fontSize="8.5" fill="#888" fontFamily="Courier New, monospace">(c) Microsoft Corporation.</text>
            {/* Prompt + command */}
            <text x="10" y="78" fontSize="9" fill="#ccc" fontFamily="Courier New, monospace">C:\Users\Nutzer{">"}</text>
            <text x="107" y="78" fontSize="9" fill="#fff" fontFamily="Courier New, monospace">ipconfig</text>
            {/* Cursor block */}
            <rect x="166" y="68" width="8" height="12" fill="#fff" opacity="0.75" />
            {/* Hint bar */}
            <rect x="0" y="108" width="300" height="22" fill="rgba(0,120,212,0.2)" />
            <text x="150" y="122" textAnchor="middle" fontSize="8" fill="#93c5fd">ipconfig eintippen → Enter drücken</text>
          </svg>
        </div>
      </div>

      {/* Step 3 */}
      <div className="flex gap-3">
        <span className="shrink-0 w-6 h-6 rounded-full bg-blue-600 text-white text-xs font-bold flex items-center justify-center mt-0.5">
          3
        </span>
        <div className="flex-1 min-w-0">
          <p className="text-sm text-gray-700 mb-3">
            Den Abschnitt <strong>„WLAN-Adapter"</strong> oder <strong>„Ethernet-Adapter"</strong> suchen –
            die <strong>IPv4-Adresse</strong> ist rot markiert.
          </p>
          <svg viewBox="0 0 300 175" xmlns="http://www.w3.org/2000/svg" className="w-full max-w-sm mx-auto block rounded-lg" aria-hidden="true">
            <rect width="300" height="175" rx="5" fill="#0c0c0c" />
            <CmdTitleBar />
            {/* Output */}
            <text x="10" y="44" fontSize="8.5" fill="#ccc" fontFamily="Courier New, monospace">C:\Users\Nutzer{">"} ipconfig</text>
            <text x="10" y="58" fontSize="8.5" fill="#ccc" fontFamily="Courier New, monospace">Windows-IP-Konfiguration</text>
            <text x="10" y="73" fontSize="8.5" fill="#aaa" fontFamily="Courier New, monospace">WLAN-Adapter WLAN:</text>
            <text x="10" y="86" fontSize="8.5" fill="#666" fontFamily="Courier New, monospace">   Verbindungsbez.: ALB-WLAN</text>
            {/* Highlighted IPv4 row */}
            <rect x="5" y="91" width="289" height="17" rx="2" fill="rgba(239,68,68,0.18)" />
            <rect x="5" y="91" width="289" height="17" rx="2" fill="none" stroke="#ef4444" strokeWidth="1.5" />
            <text x="10" y="103" fontSize="8.5" fill="#f8f8f8" fontFamily="Courier New, monospace">   IPv4-Adresse. . . .: </text>
            <text x="135" y="103" fontSize="8.5" fill="#fbbf24" fontFamily="Courier New, monospace" fontWeight="bold">192.168.1.42</text>
            {/* Red arrow */}
            <polygon points="295,99.5 300,95 300,104" fill="#ef4444" />
            <text x="10" y="120" fontSize="8.5" fill="#555" fontFamily="Courier New, monospace">   Subnetzmaske . . .: 255.255.255.0</text>
            <text x="10" y="133" fontSize="8.5" fill="#555" fontFamily="Courier New, monospace">   Standardgateway  : 192.168.1.1</text>
            {/* Label badge */}
            <rect x="8" y="145" width="148" height="14" rx="3" fill="rgba(239,68,68,0.18)" />
            <text x="82" y="155" textAnchor="middle" fontSize="8" fill="#fca5a5">← Das ist deine IP-Adresse</text>
          </svg>
        </div>
      </div>
    </div>
  );
}
